import { Box, MenuItem } from '@mui/material';
import Select from '../forms/fields/select';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

const TeamColorPicker = ({ name, defaultValue }) => {
  const { control, setValue } = useFormContext();

  // Default value is set to 'green' if not provided
  // useEffect(() => {
  //   if (!defaultValue) {
  //     setValue(name, 'green');
  //   } else {
  //     setValue(name, defaultValue);
  //   }
  // }, [defaultValue, name, setValue]);

  //   useEffect(() => {
  //   setValue(name, defaultValue || 'green', { shouldDirty: false });
  // }, [defaultValue, name, setValue]);

  return (
    <Box>
      <Select control={control} name={name} defaultValue={defaultValue || 'green'}>
        <MenuItem value={'green'}>
          <Box
            sx={{
              bgcolor: 'green.main',
              width: 20,
              height: 20,
              borderRadius: '100%'
            }}
          />
        </MenuItem>
        <MenuItem value={'red'}>
          <Box
            sx={{
              bgcolor: 'red.main',
              width: 20,
              height: 20,
              borderRadius: '100%'
            }}
          />
        </MenuItem>
        <MenuItem value={'blue'}>
          <Box
            sx={{
              bgcolor: 'blue.main',
              width: 20,
              height: 20,
              borderRadius: '100%'
            }}
          />
        </MenuItem>
        <MenuItem value={'yellow'}>
          <Box
            sx={{
              bgcolor: 'yellow.main',
              width: 20,
              height: 20,
              borderRadius: '100%'
            }}
          />
        </MenuItem>
      </Select>
    </Box>
  );
};

export default TeamColorPicker;
